import React from 'react';
import LinkButton from './LinkButton';

function LinksSection({ links, stripStyle, radius, fontColor }) {
  if (!links.length) {
    return <div className="container"><p className="text-center text-white muted">Sem links ainda</p></div>;
  }
  return (
    <div className="container">
      <div className="row">
        {links.map((lnk) => (
          <div key={lnk.linkID} className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 mx-auto">
            <LinkButton
              title={lnk.title}
              url={lnk.url}
              stripStyle={stripStyle}
              radius={radius}
              fontColor={fontColor}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(LinksSection);
